import { render, staticRenderFns } from "./BlockHelpList.vue?vue&type=template&id=1c59bfb8&"
import script from "./BlockHelpList.vue?vue&type=script&lang=js&"
export * from "./BlockHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports